import type { SocialProvider } from "@artha/types";

export const queryKeys = {
  profileReadiness: () => ["profileReadiness"] as const,
  profileSummary: () => ["profileSummary"] as const,
  currentUser: () => ["currentUser"] as const,
  socialRedirect: (provider?: SocialProvider) => ["socialRedirect", provider ?? ""] as const,
  enrichmentRun: () => ["enrichment", "run"] as const,
  enrichmentStatus: () => ["enrichment", "status"] as const,

  // New step-based enrichment keys
  readProfile: () => ["enrichment", "readProfile"] as const,
  identifyNiche: () => ["enrichment", "identifyNiche"] as const,

  // Legacy enrichment keys
  niche: (profileUrl?: string) => ["niche", profileUrl ?? ""] as const,
  profileBuild: (profileUrl?: string) => ["profileBuild", profileUrl ?? ""] as const,
  opportunities: () => ["opportunities", "run"] as const,
  opportunityCheck: () => ["opportunities", "check"] as const,
  manualNiche: () => ["manualNiche"] as const,
  predictKeywords: (nicheTags: string[] = []) => ["predictKeywords", ...nicheTags] as const,
  linkProfile: (provider?: string) => ["linkProfile", provider ?? ""] as const,
  myLinkProfile: () => ["myLinkProfile"] as const,
  audience: {
    all: () => ["audience"] as const,
    candidates: (params: Record<string, unknown> = {}) => ["audience", "candidates", params] as const,
  },
  postStudioBootstrap: () => ["postStudio", "bootstrap"] as const,
  referralInvite: (creatorUniqueId: string) => ["referrals", "public", creatorUniqueId] as const,
  referralDashboard: () => ["referrals", "dashboard"] as const,
  referralPayouts: () => ["referrals", "payouts"] as const,
  jobs: (params: Record<string, unknown> = {}) => ["jobs", params] as const,
  publicJobs: (username: string, params: Record<string, unknown> = {}) => ["publicJobs", username, params] as const,
  jobFilters: (params: Record<string, unknown> = {}) => ["jobFilters", params] as const,
  companyFilters: (params: Record<string, unknown> = {}) => ["companyFilters", params] as const,
  jobCount: (params: Record<string, unknown> = {}) => ["jobCount", params] as const,
  logout: () => ["logout"] as const,

  // Revenue-hub keys
  revenue: {
    all: () => ["revenue"] as const,
    metrics: (period: string = 'month') => [...queryKeys.revenue.all(), "metrics", period] as const,
    dashboardMetrics: () => [...queryKeys.revenue.all(), "dashboardMetrics"] as const,
    monthlyRecap: () => [...queryKeys.revenue.all(), "monthlyRecap"] as const,
    publicImpact: (creatorId: string) => [...queryKeys.revenue.all(), "publicImpact", creatorId] as const,
    timeSeries: (params: Record<string, unknown> = {}) => [...queryKeys.revenue.all(), "timeSeries", params] as const,
    leaderboard: (params: Record<string, unknown> = {}) => [...queryKeys.revenue.all(), "leaderboard", params] as const,
  },
  developer: {
    all: () => ["developer"] as const,
    apiKeys: () => [...queryKeys.developer.all(), "apiKeys"] as const,
    apiKeyUsage: (id: string, params: Record<string, unknown> = {}) =>
      [...queryKeys.developer.all(), "apiKeyUsage", id, params] as const,
  },
  payouts: {
    all: () => ["payouts"] as const,
    lists: () => [...queryKeys.payouts.all(), "list"] as const,
    list: (params: Record<string, unknown> = {}) => [...queryKeys.payouts.lists(), params] as const,
    details: () => [...queryKeys.payouts.all(), "details"] as const,
    panDocument: () => [...queryKeys.payouts.details(), "panDocument"] as const,
    detail: (id: string) => [...queryKeys.payouts.all(), "detail", id] as const,
  },
};
